import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MountainIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.2994 15.8818C14.918 15.6845 15.1804 14.9576 14.8677 14.3804L8.9336 3.42599C8.52859 2.67835 7.47141 2.67836 7.0664 3.42599L1.1323 14.3804C0.819612 14.9576 1.08197 15.6845 1.70057 15.8818C1.8343 15.9245 1.9683 15.9657 2.10257 16.0056C5.96173 17.1519 10.0383 17.1519 13.8974 16.0056C14.0317 15.9657 14.1657 15.9245 14.2994 15.8818ZM10.467 9.67301L8 5.11893L5.44099 9.84285C5.70485 10.2325 6.06836 10.6843 6.06836 10.6843C6.06836 10.6843 7.56836 9.68423 8.06836 9.68427C8.51122 9.6843 9.56836 10.6842 9.56836 10.6842C9.95257 10.4054 10.2381 10.0219 10.467 9.67301Z"
		/>
	</svg>
))
